import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("bc_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrg(data.organization);
    } catch {
      localStorage.removeItem("bc_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bc_token", data.token);
    await loadMe();
    return data.user;
  };

  const impersonate = async (orgId) => {
    const { data } = await api.post(`/admin/impersonate/${orgId}`);
    localStorage.setItem("bc_token", data.token);
    await loadMe();
  };

  const stopImpersonate = async () => {
    const { data } = await api.post("/admin/stop-impersonate");
    localStorage.setItem("bc_token", data.token);
    await loadMe();
    window.location.href = "/app";
  };

  const logout = () => {
    localStorage.removeItem("bc_token");
    setUser(null);
    setOrg(null);
    window.location.href = "/login";
  };

  const effectiveRole = user ? (user.impersonating ? "client_admin" : user.role) : null;

  return (
    <AuthContext.Provider value={{ user, org, loading, effectiveRole, login, logout, impersonate, stopImpersonate, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
